module.exports = __webpack_public_path__ + "img/kolor-01.41802e8f.png";